export default "__VITE_ASSET__CT94xzsE__"